module.exports = __webpack_public_path__ + "static/img/strona_043.f789cd32.jpg";